import {Injectable} from '@angular/core';
import {ApiService} from '@drl/core/api/api.service';
import {CreateAppointment} from './shared/commands/add-appointment.command';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {AppointmentAdapter} from './shared/adapters/appointment-adapters.service';
import {AppointmentBulk} from './appointment-bulk.model';
import {PrescriptionBulk} from './prescription-bulk.model';
import {CreatePrescriptionBulk} from './shared/commands/add-prescriptions.command';
import {BulkPrescriptionAdapter} from './shared/adapters/prescription-adapters.service';
import {Prescriptions} from '../patients/shared/models';
import {CreatePrescription} from './shared/commands/add-single-prescription.command';
import {AnyAdapter} from '@drl/core/api/adapters/any-adapter.service';
import {SinglePrescriptionAdapter} from './shared/adapters/single-prescription-adapter.service';
import {UploadPrescriptionFileForPatientCommand} from '../patients/prescription-list/commands/upload-pres-files.command';
import {UpdatePrescription} from './shared/commands/update-single-prescription.command';

@Injectable()
export class PatientDataFacadeService {
  constructor(
    private readonly apiService: ApiService,
    private readonly apptAdapter: AppointmentAdapter,
    private readonly prescAdapter: BulkPrescriptionAdapter,
    private readonly singlePrescAdapter: SinglePrescriptionAdapter,
    private readonly anyAdapter: AnyAdapter,
  ) {}

  createBulkAppointment(appts: AppointmentBulk) {
    const command: CreateAppointment<AppointmentBulk> = new CreateAppointment(
      this.apiService,
      this.apptAdapter,
    );
    command.parameters = {
      data: appts,
      headers: new HttpHeaders().set('X-Skip-Error-Toast', 'true'),
    };
    return command.execute();
  }

  createBulkPrescription(prescriptions: PrescriptionBulk) {
    const command: CreatePrescriptionBulk<PrescriptionBulk> =
      new CreatePrescriptionBulk(this.apiService, this.prescAdapter);
    command.parameters = {
      data: prescriptions,
      headers: new HttpHeaders().set('X-Skip-Error-Toast', 'true'),
    };
    return command.execute();
  }

  createPrescription(prescription: Prescriptions) {
    const command: CreatePrescription<Prescriptions> = new CreatePrescription(
      this.apiService,
      this.anyAdapter,
    );
    let params = new HttpParams();
    if (Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown') {
      params = params.set(
        'tz',
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      );
    } else {
      // default time zone in brazil -3 if system unable to detect timezone
      params = params.set('tz', 'America/Bahia');
    }
    command.parameters = {
      data: prescription,
      headers: new HttpHeaders().set('X-Skip-Error-Toast', 'true'),
      query: params, // Removed as 'query' is not a known property
    };
    return command.execute();
  }

  updatePartialPrescription(id, prescription: Prescriptions) {
    const command: UpdatePrescription<Prescriptions> = new UpdatePrescription(
      this.apiService,
      this.singlePrescAdapter,
      id,
    );
    let params = new HttpParams();
    if (Intl.DateTimeFormat().resolvedOptions().timeZone != 'Etc/Unknown') {
      params = params.set(
        'tz',
        Intl.DateTimeFormat().resolvedOptions().timeZone,
      );
    } else {
      // default time zone in brazil -3 if system unable to detect timezone
      params = params.set('tz', 'America/Bahia');
    }
    command.parameters = {
      data: prescription,
      query: params,
    };
    return command.execute();
  }

  UploadPrescriptionFileForPatient(id: Number, images) {
    const command: UploadPrescriptionFileForPatientCommand<FormData> =
      new UploadPrescriptionFileForPatientCommand(
        this.apiService,
        this.anyAdapter,
        id,
      );
    command.parameters = {
      data: images,
    };
    return command.execute();
  }
}
